import dynamic from 'next/dynamic'
import { DynamicHeader } from '@/features/shared/components/Headers/Header/DynamicHeader'
import {
  useIsGuestWithZipOnly,
  usePlaPopoverEligibility,
  useSubmitZipForPlaPopover,
} from '@/features/shop/components/ProductDetail/PLA/hooks'
import { useEffect } from 'react'
import { setSessionStorageItem } from '@/features/shared/utils/sessionStorage'
import { PLA_POPOVER_SESSION_STORAGE } from '@/features/shop/components/ProductDetail/constants'
import { useSearchQueryParams } from '@/features/shared/hooks/search'

const PLAGuestWithZipOnlyHeader = dynamic(
  async () =>
    (await import('@/features/shared/components/Headers/PLAGuestWithZipOnlyHeader'))
      .PLAGuestWithZipOnlyHeader,
)
const PlaPricingPopover = dynamic(
  async () => (await import('../PLA/PlaPricingPopover')).PlaPricingPopover,
  { ssr: false },
)

export const ProductDetailHeader = ({ productId }: { productId: number }) => {
  const isPlaPopoverEligible = usePlaPopoverEligibility(productId)
  const isGuestWithZipOnly = useIsGuestWithZipOnly()
  const { region_id } = useSearchQueryParams()

  if (isGuestWithZipOnly && region_id) {
    return <PdpPLAGuestWithZipOnlyHeader productId={productId} />
  }
  if (isPlaPopoverEligible) {
    return <DynamicHeader renderPlaPopover={() => <PlaPricingPopover align="center" />} />
  }
  return <DynamicHeader />
}

const PdpPLAGuestWithZipOnlyHeader = ({ productId }: { productId: number }) => {
  const submitZipForPlaPopover = useSubmitZipForPlaPopover(productId)

  useEffect(() => {
    // set PLA session storage key to true to indicate that a guest user with zip only
    // has visited the PDP so that we don't end up displaying the PLA pricing popover
    // after they sign up for a full address
    setSessionStorageItem(PLA_POPOVER_SESSION_STORAGE, 'true')
  }, [])

  return <PLAGuestWithZipOnlyHeader onSubmit={submitZipForPlaPopover} />
}
